export function countBy<T>(
  arr: T[],
  key: (item: T) => string,
): Record<string, number> {
  const result: Record<string, number> = {};
  for (const item of arr) {
    const k = key(item);
    result[k] = (result[k] ?? 0) + 1;
  }
  return result;
}

export function formatDate(isoDate: string): string {
  const date = new Date(isoDate + "T00:00:00");
  if (Number.isNaN(date.getTime())) return isoDate;
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function computeScheduleProgress(
  startDate: string,
  endDate: string,
): { label: string; percent: number } | null {
  const start = new Date(startDate + "T00:00:00").getTime();
  const end = new Date(endDate + "T00:00:00").getTime();
  const now = Date.now();

  if (!start || !end || end <= start) return null;

  const totalDays = Math.round((end - start) / 86_400_000);
  const elapsedDays = Math.max(
    0,
    Math.min(Math.round((now - start) / 86_400_000), totalDays),
  );
  const totalWeeks = Math.ceil(totalDays / 7);
  const currentWeek = Math.min(Math.floor(elapsedDays / 7) + 1, totalWeeks);
  const percent = Math.round((elapsedDays / totalDays) * 100);

  return { label: `Week ${currentWeek} of ${totalWeeks}`, percent };
}
